module.exports = __webpack_public_path__ + "static/media/yuntaishan6.46d3ae82.webp";